export default "__VITE_ASSET__DE_sH53e__"